import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import IconBoxStyle5 from '../../IconBox/IconBoxStyle5';

export default function AwardSectionStyle2({
  sectionTitle,
  sectionTitleUp,
  sectionSubTitle,
  data,
}) {
  return (
    <div className="container" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
      <SectionHeading
        title={sectionTitle}
        titleUp={sectionTitleUp}
        subTitle={sectionSubTitle}
        center
      />
      <Spacing md="72" lg="50" />
      <div className="row cs_gap_y_24">
        {data?.filter((item) => item.payment_status == 'SUCCESS').map((item, index) => (
          <div className="col-xxl-4 col-md-6" key={index} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
            <IconBoxStyle5 item={item} />
          </div>
        ))}
      </div>
    </div>
  );
}
